// @ts-check

/**
 * @function removeDuplicatedValues
 * @param {Object[]} values
 * @param {string} values.id
 * @param {string} values.name
 * @param {string} values.appId
 * @returns {Array.<{id:string, name:string, appId:string}>}
 */
function removeDuplicatedValues(values) {
	const ids = values.map((value) => value.id);
	const filtered = values.filter((value, index) => !ids.includes(value.id, index + 1));
	return filtered;
}

export default removeDuplicatedValues;
